import { render, staticRenderFns } from "./onRemoteQuery-editor.vue?vue&type=template&id=82445480&scoped=true&"
import script from "./onRemoteQuery-editor.vue?vue&type=script&lang=js&"
export * from "./onRemoteQuery-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82445480",
  null
  
)

export default component.exports